var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenPathsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#325533;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Blue_BKGD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue_Box"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.4718,
    y1: 5352.2974,
    x2: 249.6817,
    y2: 5111.9814,
    gradientTransform: "matrix(-1 0 0 -1 497.8188 5360.3823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#467840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#44753F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#416E3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9085,
    style: {
      stopColor: "#3A6338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    style: {
      stopColor: "#325533"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,27.9C0,12.6,12.6,0,27.9,0h200.1C243.4,0,256,12.6,256,27.9v200.1c0,15.4-12.6,27.9-27.9,27.9H27.9 C12.6,256,0,243.4,0,228.1V27.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.5,143.2l-17.9,9.1l-0.1-45.1l-10.5-5.5l0.1,56l-40.2,20.6l-0.2-101.6l-39-20.3l40.2-21.1l39,20.8 l0.1,38.5l11-5.8l17.3,9.2L199.5,143.2z M217.7,172.1c-2.7,3.5-7.7,5.8-13.3,6.2c-0.6,0-1.2,0.1-1.8,0.1c-4.8,0-9.2-1.4-12.3-3.6 l-59.5,30.6L40,158.6l49.9-25.5v7.2L54,158.6l18.8,9.6l17.1-8.8v7.2l-10.1,5.2l51,26.2l55.3-28.4c-0.3-0.7-0.5-1.4-0.6-2.1 c-0.4-2.6,0.3-5.3,2.1-7.6c2.7-3.5,7.7-5.8,13.3-6.2c9.5-0.7,17.8,4,18.9,10.7C220.2,167.2,219.5,169.9,217.7,172.1z M213.5,165.6 L213.5,165.6c-0.5-2.7-4.9-5.4-10.8-5.4c-0.5,0-0.9,0-1.4,0c-3.8,0.3-7.2,1.7-8.8,3.7c-0.7,0.8-0.9,1.7-0.8,2.6 c0.5,2.9,5.6,5.8,12.2,5.4c3.8-0.3,7.2-1.7,8.8-3.7C213.3,167.3,213.6,166.5,213.5,165.6z M187,184.7l26.1,13.1l-26.4,14.1 l-8.7-4.4l-44.1,22.7l-90.8-46.7l14.7-7.5l7,3.6l-7.7,3.9l76.8,39.5l37.1-19l-10.3-5.2L187,184.7z M187.1,191.9l-12.6,6.7l12.1,6.1 l12.6-6.7L187.1,191.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.5,138.4l-17.9,9.1l-0.1-45.1L169.1,97l0.1,56L129,173.5L128.8,72l-39-20.3L130,30.6l39,20.8l0.1,38.5 l11-5.8l17.3,9.2L197.5,138.4z M215.8,167.3c-2.7,3.5-7.7,5.8-13.3,6.2c-0.6,0-1.2,0.1-1.8,0.1c-4.8,0-9.2-1.4-12.3-3.6l-59.5,30.6 L38,153.8l51.8-26.6v7.2L52,153.8l18.8,9.6l19-9.8v7.2l-12,6.2l51,26.2l55.3-28.4c-0.3-0.7-0.5-1.4-0.6-2.1 c-0.4-2.6,0.3-5.3,2.1-7.6c2.7-3.5,7.7-5.8,13.3-6.2c9.5-0.7,17.8,4,18.9,10.7C218.3,162.4,217.6,165.1,215.8,167.3z M211.5,160.8 L211.5,160.8c-0.5-2.7-4.9-5.4-10.8-5.4c-0.5,0-0.9,0-1.4,0c-3.8,0.3-7.2,1.7-8.8,3.7c-0.7,0.8-0.9,1.7-0.8,2.6 c0.5,2.9,5.6,5.8,12.2,5.4c3.8-0.3,7.2-1.7,8.8-3.7C211.4,162.5,211.7,161.7,211.5,160.8z M185.1,179.9l26.1,13.1l-26.4,14.1 l-8.7-4.4l-44.1,22.7l-90.8-46.7l14.7-7.5l7,3.6l-7.7,3.9l76.8,39.5l37.1-19l-10.3-5.2L185.1,179.9z M185.2,187.1l-12.6,6.7 l12.1,6.1l12.6-6.7L185.2,187.1z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenPathsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/open-paths-icon.ff0428ba943c17d9853fcddb2061effd.svg";